import React from 'react';
import styled from 'styled-components';
import SpotdoveLogo from './SpotdoveLogo';
import BrandWordmark, { BrandWordmarkVariant } from './BrandWordmark';

const Lockup = styled.span<{ $gap: number }>`
  display: inline-flex;
  align-items: center;
  gap: ${({ $gap }) => $gap}px;
  min-width: 0;
`;

export interface BrandLockupProps {
  /** Logo mark height in px (square aspect ratio). */
  logoHeight?: number;
  /** Space between mark and wordmark. */
  gap?: number;
  variant?: BrandWordmarkVariant;
  className?: string;
  children?: React.ReactNode;
}

/** Logo mark + Spotdove wordmark for headers, footers, and slides. */
const BrandLockup: React.FC<BrandLockupProps> = ({
  logoHeight = 28,
  gap = 10,
  variant = 'header',
  className,
  children = 'Spotdove',
}) => (
  <Lockup className={className} $gap={gap} aria-label={typeof children === 'string' ? children : 'Spotdove'}>
    <SpotdoveLogo height={logoHeight} decorative />
    <BrandWordmark $variant={variant}>{children}</BrandWordmark>
  </Lockup>
);

export default BrandLockup;
